import { ChangeEvent, FormEvent, useRef, useState } from 'react'
import Popover from 'react-bootstrap/Popover'
import { Placement } from 'react-bootstrap/types'
import { Button, Form, Modal, Tooltip } from 'react-bootstrap'
import style from './MoveToPosition.module.scss'
import { FormattedMessage } from 'react-intl'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft'

interface MoveToPositionProps {
    position: number
    maxPosition: number
    onSubmit: (toPosition: number) => void
    disabled: boolean
    className?: string
    popoverPlacement?: Placement
}

export const MoveToPosition = (props: MoveToPositionProps) => {
    const { position, maxPosition, onSubmit, disabled, className, popoverPlacement = 'right' } = props

    const [toPosition, setToPosition] = useState(maxPosition)
    const inputRef = useRef<HTMLInputElement>(null)

    const handleOnSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        inputRef.current?.blur()
        onSubmit(toPosition)
    }

    const handlePositionChange = (e: ChangeEvent<HTMLInputElement>) => {
        const cleanValue = e.target.value.replace(/^0+/, '')
        const newPosition = Number(cleanValue)
        const isNewPositionValid = !(newPosition > maxPosition)

        if (isNewPositionValid) {
            // Convert string to get rid of zero prefix in input type number
            setToPosition(newPosition.toString() as unknown as number)
        }
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Body>
                <Form onSubmit={handleOnSubmit}>
                    <Form.Label>Current position:</Form.Label>
                    <Form.Control
                        type="text"
                        value={position}
                        className={style.currentPositionInput}
                        onChange={() => {}} // dummy
                    />
                    <Form.Label>Move to position:</Form.Label>
                    <Form.Control
                        ref={inputRef}
                        type="number"
                        min="1"
                        max={maxPosition}
                        value={toPosition}
                        onChange={handlePositionChange}
                    />
                    <Modal.Footer className="pe-0 py-3">
                        <Button
                            variant="primary"
                            className="app-btn-main app-btn-apply me-0"
                            type="submit"
                        >
                            <FormattedMessage id="apply" />
                        </Button>
                    </Modal.Footer>
                </Form>
            </Popover.Body>
        </Popover>
    )

    return (
        <OverlayTrigger
            trigger="click"
            placement={popoverPlacement}
            overlay={popover}
            rootClose // close on outside click
            delay={100}
        >
            <span className={disabled ? style.disabled : ''}>
                <OverlayTrigger
                    placement="top"
                    rootClose // close on outside click
                    overlay={
                        <Tooltip id="move2Position">Move to position</Tooltip>
                    }
                >
                    <button
                        disabled={disabled}
                        className={`${style.btnMoveTo} ${className}`}
                    >
                        <FontAwesomeIcon
                            rotation={90}
                            icon={faArrowRightArrowLeft}
                        />
                    </button>
                </OverlayTrigger>
            </span>
        </OverlayTrigger>
    )
}